/**
 * Short confirmations shown at the bottom of the screen ("Added … to …'s
 * family", with Undo). One at a time: a new one replaces the last, as a
 * second click should not stack a column of notices.
 */
import { create } from "zustand";

export interface ToastAction {
  label: string;
  run: () => void;
}

export interface Toast {
  id: number;
  text: string;
  action?: ToastAction;
  error?: boolean;
}

interface Toasts {
  current: Toast | null;
  show: (toast: Omit<Toast, "id">) => number;
  dismiss: (id: number) => void;
}

let next = 0;

export const useToasts = create<Toasts>((set) => ({
  current: null,
  show: (toast) => {
    next += 1;
    const id = next;
    set({ current: { ...toast, id } });
    return id;
  },
  dismiss: (id) => set((s) => (s.current?.id === id ? { current: null } : s)),
}));

/** Show a toast from outside React. */
export const toast = (t: Omit<Toast, "id">): number => useToasts.getState().show(t);
